import { Link, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'
import {
  LayoutDashboard,
  Calendar,
  Users,
  UserCircle,
  HandHeart,
  Menu,
} from 'lucide-react'

const navigation = [
  { name: 'Principal', href: '/', icon: LayoutDashboard },
  { name: 'Contribuição', href: '/contribuicao', icon: HandHeart },
  { name: 'Eventos', href: '/eventos', icon: Calendar },
  { name: 'Ministérios', href: '/ministerios', icon: Users },
  { name: 'Membros', href: '/membros', icon: UserCircle },
]

export function MobileNav() {
  const location = useLocation()

  return (
    <nav className="border-t bg-card/95 backdrop-blur-lg supports-[backdrop-filter]:bg-card/80">
      <div className="grid grid-cols-6 px-2 py-2">
        {navigation.map((item) => {
          const isActive = location.pathname === item.href
          return (
            <Link
              key={item.name}
              to={item.href}
              className={cn(
                'relative flex flex-col items-center justify-center gap-1.5 rounded-xl px-2 py-2.5 text-xs font-medium transition-all',
                isActive ? 'text-primary' : 'text-muted-foreground active:scale-95'
              )}
            >
              <div className="relative">
                <item.icon
                  className={cn('h-5 w-5 transition-all', isActive && 'scale-110')}
                  strokeWidth={isActive ? 2.5 : 2}
                />
                {isActive && (
                  <motion.div
                    layoutId="mobileActiveTab"
                    className="absolute inset-0 -z-10 rounded-lg bg-primary/10"
                    transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                  />
                )}
              </div>
              <span
                className={cn('truncate text-[10px] transition-all', isActive && 'font-semibold')}
              >
                {item.name}
              </span>
              {isActive && (
                <motion.div
                  layoutId="mobileActiveDot"
                  className="absolute bottom-0 h-1 w-8 rounded-full bg-primary"
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                />
              )}
            </Link>
          )
        })}
        
        {/* Menu Button */}
        <Link
          to="/menu-mobile"
          className={cn(
            'relative flex flex-col items-center justify-center gap-1.5 rounded-xl px-2 py-2.5 text-xs font-medium transition-all',
            location.pathname === '/menu-mobile' ? 'text-primary' : 'text-muted-foreground active:scale-95'
          )}
        >
          <div className="relative">
            <Menu
              className={cn('h-5 w-5 transition-all', location.pathname === '/menu-mobile' && 'scale-110')}
              strokeWidth={location.pathname === '/menu-mobile' ? 2.5 : 2}
            />
            {location.pathname === '/menu-mobile' && (
              <motion.div
                layoutId="mobileActiveTab"
                className="absolute inset-0 -z-10 rounded-lg bg-primary/10"
                transition={{ type: 'spring', stiffness: 500, damping: 30 }}
              />
            )}
          </div>
          <span
            className={cn('truncate text-[10px] transition-all', location.pathname === '/menu-mobile' && 'font-semibold')}
          >
            Menu
          </span>
          {location.pathname === '/menu-mobile' && (
            <motion.div
              layoutId="mobileActiveDot"
              className="absolute bottom-0 h-1 w-8 rounded-full bg-primary"
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ type: 'spring', stiffness: 500, damping: 30 }}
            />
          )}
        </Link>
      </div>
      {/* Safe area for iOS devices */}
      <div className="h-safe-area-inset-bottom bg-card" />
    </nav>
  )
}
